import * as Sentry from '@sentry/browser';

export const sendUserIdToGA = (userId: string) => {
  try {
    gtag('event', 'user_id', {
      user_id: userId,
      user_properties: { crm_id: userId },
      send_to: process.env.NEXT_PUBLIC_GA4_CROSS_MEASUREMENT_ID ?? '',
    });
  } catch (e) {
    Sentry.captureException(e);
  }
};
